/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loading from "../Common/Loading/Loading";

const ProfileSidebar = () => {
  const [userDetails, setUserDetails] = useState("");
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      Axios.get("https://lawacademyadmin.icicle.dev/api/studentWiseData", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        if (res.status === 200) {
          setUserDetails(res.data);
          setShow(true);
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          navigate("/login");
          setShow(false);
        }
        // console.log(res.data);
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  if (!show) {
    return <Loading />;
  }
  return (
    <>
      <div className="col-lg-4 col-md-4">
        <nav
          className=""
          style={{ boxShadow: "-2px 2px 20px 5px rgba(28,36,91,0.44)", borderRadius: "10px" }}
        >
          <div className="offcanvas-start" tabIndex="-1" id="offcanvasSideNavbar">
            <div className="offcanvas-body d-block px-lg-0">
              <div className="overflow-hidden">
                <div
                  className="d-flex flex-column"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <div style={{ marginTop: "10px", width: "100px", height: "100px" }}>
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                      src={
                        userDetails?.image
                          ? `https://lawacademyadmin.icicle.dev/${userDetails.image}`
                          : "https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
                      }
                      alt="user profile"
                    />
                  </div>
                  <div style={{ padding: "5px 0px" }}>
                    <div style={{ fontSize: "15px", paddingBottom: "5px", fontWeight: "bold" }}>
                      <span>{userDetails?.name}</span>
                    </div>
                    <div>
                      <span>{userDetails?.email}</span>
                    </div>
                  </div>
                </div>

                <div className="card-body py-0">
                  <hr style={{ margin: "0px" }} />
                  <ul
                    className="nav nav-link-secondary flex-column fw-bold gap-2"
                    style={{ fontSize: "larger" }}
                  >
                    <li>
                      <Link to="/">
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="me-2 h-20px fa-fw"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                              />
                            </svg>
                          </div>
                          <p>Home</p>
                        </div>
                      </Link>
                    </li>
                    <hr style={{ margin: "0px" }} />
                    <li className="nav-item">
                      <Link to="/userProfile">
                        <div
                          className="nav-align"
                          style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        >
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="me-2 h-20px fa-fw"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                            </svg>
                          </div>
                          <p>My Profile</p>
                        </div>
                      </Link>
                    </li>
                    <hr style={{ margin: "0px" }} />
                    {/* <li className="nav-item">
                      <Link to="/editProfile">
                        <div
                          className="nav-align"
                          style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        >
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="me-2 h-20px fa-fw"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
                              />
                            </svg>
                          </div>
                          <p>Edit Profile</p>
                        </div>
                      </Link>
                    </li> */}
                    <hr style={{ margin: "0px" }} />
                    <li className="nav-item">
                      <Link to="/review">
                        <div
                          className="nav-align"
                          style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        >
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="me-2 h-20px fa-fw"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                          </div>
                          <p>Review</p>
                        </div>
                      </Link>
                    </li>

                    {/* <hr style={{ margin: "0px" }} /> */}
                    {/* <li className="nav-item">
                      <Link to="/payment">
                        <div
                          className="nav-align"
                          style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        >
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="me-2 h-20px fa-fw"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                              />
                            </svg>
                          </div>
                          <p>Payment Details</p>
                        </div>
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default ProfileSidebar;
